/* Shopify filters before paginating. A few unavailable examples sit below the main list. */
(function () {
  var observer;
  function setup() {
    var root = document.querySelector('[data-mo-collection]');
    var container = document.getElementById('ProductGridContainer');
    if (!root || !container) return;
    document.querySelectorAll('.active-facets').forEach(function (group) {
      group.classList.toggle('mo-no-active-filters', !group.querySelector('.active-facets__button'));
    });
    var grid = container.querySelector('#product-grid');
    if (!grid || grid.dataset.moReady) return;
    grid.dataset.moReady = '1';
    var params = new URLSearchParams(location.search);
    var unavailable = params.get('filter.v.availability') === '0';
    ['ProductCount','ProductCountDesktop'].forEach(function (id) {
      var count = document.getElementById(id);
      if (count) count.textContent = grid.dataset.moCount + (unavailable ? ' agotados' : ' disponibles');
    });
    grid.querySelectorAll(':scope > li.grid__item').forEach(function (li) {
      li.classList.toggle('mo-card--unavailable', !!li.querySelector('[data-mo-available="false"]'));
    });
    if (unavailable && !container.querySelector('.mo-available-return')) {
      var back = document.createElement('a');
      var target = new URL(location.href);
      target.searchParams.set('filter.v.availability','1');
      target.searchParams.delete('page');
      back.href = target.href;
      back.className = 'link mo-archive-more mo-available-return page-width';
      back.textContent = 'Volver a los disponibles';
      container.prepend(back);
    }
    if (unavailable || Number(params.get('page') || 1) > 1 || container.querySelector('.mo-archive-preview')) return;
    var request = new URL(location.href);
    request.searchParams.set('filter.v.availability', '0');
    request.searchParams.set('page','1');
    request.searchParams.set('section_id',grid.dataset.id);
    request.searchParams.set('mo_view','catalog');
    fetch(request.href).then(function(r) { if (!r.ok) throw Error('Unavailable preview'); return r.text(); }).then(function(html) {
      if (!grid.isConnected) return;
      var doc = new DOMParser().parseFromString(html,'text/html');
      var candidates = Array.from(doc.querySelectorAll('#product-grid > li.grid__item')).filter(function(li) {
        return !!li.querySelector('[data-mo-available="false"]');
      }).slice(0,12);
      if (!candidates.length) return;
      var section = document.createElement('section');
      section.className = 'mo-archive-preview page-width';
      section.setAttribute('aria-labelledby','mo-archive-heading');
      var heading = document.createElement('h2');
      heading.id = 'mo-archive-heading';
      heading.textContent = 'Ya no disponibles';
      var intro = document.createElement('p');
      intro.textContent = 'Artículos agotados. Puedes consultar sus fichas.';
      var list = document.createElement('ul');
      list.className = grid.tagName === 'UL' ? grid.className : 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
      list.classList.remove('collection--empty');
      list.classList.add('mo-archive-track');
      candidates.forEach(function(li) {
        li.classList.add('mo-card--unavailable','scroll-trigger--cancel');
        li.classList.remove('animate--slide-in','scroll-trigger');
        li.removeAttribute('data-cascade');
        li.removeAttribute('style');
        list.appendChild(li);
      });
      var more = document.createElement('a');
      request.searchParams.delete('section_id');
      more.href = request.href;
      more.className = 'link mo-archive-more';
      more.textContent = 'Ver todos los agotados';
      section.append(heading,intro,list,more);
      container.appendChild(section);
      initCarousel(section, list);
    }).catch(function () { /* Hide optional section if Shopify supplies no valid data. */ });
  }

  function initCarousel(section, list) {
    list.id = 'mo-archive-track';
    list.setAttribute('aria-label','Artículos no disponibles de esta categoría');
    list.setAttribute('tabindex','0');
    section.setAttribute('aria-roledescription','carrusel');
    var controls = document.createElement('div');
    controls.className = 'mo-archive-controls';
    function button(label, text) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mo-archive-arrow';
      b.setAttribute('aria-label',label); b.setAttribute('aria-controls',list.id);
      b.textContent = text; controls.appendChild(b); return b;
    }
    var prev = button('Ver artículos anteriores','‹');
    var status = document.createElement('span');
    status.className = 'mo-archive-position visually-hidden'; controls.appendChild(status);
    var next = button('Ver más artículos','›');
    var pause = button('Pausar movimiento automático','Ⅱ');
    pause.classList.add('mo-archive-pause'); pause.setAttribute('aria-pressed','false');
    var header = document.createElement('div'); header.className = 'mo-archive-header'; var copy = document.createElement('div'); copy.className = 'mo-archive-heading-copy'; copy.appendChild(section.querySelector('h2')); copy.appendChild(section.querySelector('p')); header.append(copy,controls); section.insertBefore(header,list);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var paused = false, focused = false, visible = false, interacting = false, resumeAt = 0;
    var originalCount = list.children.length;
    var originals = Array.from(list.children);
    originals.forEach(function(item) {
      var copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden','true'); copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function(el){el.setAttribute('tabindex','-1');});
      copy.classList.add('mo-archive-copy');
      copy.querySelectorAll('[id]').forEach(function(el){el.removeAttribute('id');});
      copy.removeAttribute('id'); list.appendChild(copy);
    });
    function cycleWidth() { return originalCount * step(); }
    function hold() { resumeAt = performance.now() + 1600; }
    list.addEventListener('pointerdown',function(){interacting=true;hold();});
    window.addEventListener('pointerup',function(){if(interacting){interacting=false;hold();}});
    list.addEventListener('pointercancel',function(){interacting=false;hold();});
    function step() {
      return list.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0);
    }
    function update() {
      var size = step();
      var first = Math.floor((list.scrollLeft % cycleWidth()) / size) + 1;
      var count = Math.max(1,Math.floor((list.clientWidth + 16) / size));
      status.textContent = first + '–' + Math.min(originalCount,first + count - 1) + ' de ' + originalCount;
      prev.disabled = false;
      next.disabled = false;
      controls.hidden = cycleWidth() <= list.clientWidth + 2;
      pause.hidden = reduced.matches;
    }
    function move(direction, automatic) {
      hold();
      if (direction < 0 && list.scrollLeft < step()) list.scrollLeft += cycleWidth();
      var end = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      if (automatic && end) list.scrollTo({left:0,behavior:reduced.matches?'instant':'smooth'});
      else list.scrollBy({left: direction * step(),behavior:reduced.matches?'instant':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1,false);});
    next.addEventListener('click',function(){move(1,false);});
    pause.addEventListener('click',function(){
      paused = !paused;
      pause.textContent = paused ? '▷' : 'Ⅱ';
      pause.setAttribute('aria-pressed',String(paused));
      pause.setAttribute('aria-label',paused ? 'Reanudar movimiento automático' : 'Pausar movimiento automático');
    });
    list.addEventListener('keydown',function(event){
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); move(event.key === 'ArrowRight'?1:-1,false);
      }
    });
    list.addEventListener('scroll',update,{passive:true});
    section.addEventListener('focusin',function(event){focused=event.target.matches(':focus-visible');});
    section.addEventListener('focusout',function(){focused=false;});
    var visibility = new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;},{threshold:0});
    visibility.observe(list);
    var resize = new ResizeObserver(update); resize.observe(list);
    var previous = 0, fractional = 0;
    function animate(now) {
      if (!section.isConnected) { visibility.disconnect(); resize.disconnect(); return; }
      var elapsed = previous ? Math.min(now - previous, 50) : 0; previous = now;
      if (visible && !paused && !focused && !interacting && now > resumeAt && !document.hidden && !reduced.matches && !controls.hidden) {
        fractional += elapsed * 0.032; var pixels = Math.floor(fractional); fractional -= pixels; list.scrollLeft += pixels;
        if (list.scrollLeft >= cycleWidth()) list.scrollLeft -= cycleWidth();
      }
      window.requestAnimationFrame(animate);
    }
    window.requestAnimationFrame(animate);
    update();
  }

  function start() {
    setup();
    observer = new MutationObserver(setup);
    var target = document.getElementById('MainContent');
    if (target) observer.observe(target,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
